export enum ETimeoffValidationType {
    None,
    DateRangeError,
    BalanceError,
    DuplicatedDateError,
    ProhibitionEndDateError,
    HolidayConflictError,
    MaxPunchSetLengthError,
    PayTypeError,
    LockedError,
    EmployeeInactive,
    PermissionError
}
